@if (callEvents && callEvents.length === 0) {
	<empty-state icon="fa fa-search" message="{{ 'home.empty_state_alarms' | translate }}" />
}
<sorted-list-view [header]="false" [items]="callEvents" [key]="['callDate']" [reverse]="true">
	<ng-template let-callEvent>
		<call-event-item
			[alarmsPermission]="alarmsPermission()"
			[callEvent]="callEvent"
			(click)="selectedCallEvent.next(callEvent)"
		/>
	</ng-template>
</sorted-list-view>
